import { isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/pro-light-svg-icons";

interface ImagePreviewTypes {
  imageId?: string;
  storageDirectory?: string;
}

function ImagePreview({
  imageId,
  storageDirectory = "images",
}: ImagePreviewTypes) {
  return (
    <div className={"imageView"}>
      {!isEmpty(imageId) ? (
        <img
          className="max-h-32 max-w-32"
          src={`/api/storage/${storageDirectory}/${imageId}/${
            storageDirectory === "images" ? "get/200x200" : "preview"
          }`}
        />
      ) : (
        <div className="imageIcon w-32 h-32 bg-gray-100 text-gray-400 text-center pt-4">
          <FontAwesomeIcon icon={faImage} className="text-8xl" />
        </div>
      )}
    </div>
  );
}

export default ImagePreview;
